"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const styleOverrides = {
  fab: ({
    theme
  }) => ({
    width: 40,
    height: 40,
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.common.white
    }
  })
};
var _default = exports.default = {
  styleOverrides
};
//# sourceMappingURL=MuiSpeedDial.js.map